import { render, staticRenderFns } from "./adminAccounts.vue?vue&type=template&id=6cb09794&scoped=true"
import script from "./adminAccounts.vue?vue&type=script&lang=js"
export * from "./adminAccounts.vue?vue&type=script&lang=js"
import style0 from "./adminAccounts.vue?vue&type=style&index=0&id=6cb09794&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb09794",
  null
  
)

export default component.exports